import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import ErpAxios from '../../../api/ErpAxios';
import Loader from '../../Loader';

const app_env = process.env.REACT_APP_ENV;
const Options = (props) => {
    console.log('Options props')
   
    const serviceInfo = props.globalServiceTypes.find(
      service => service.key === props.serviceType
  );
    let service_title = serviceInfo?.label || 'Service';

     const BOOKING_URL = '/calendar/inspections';
    const [selectedTimeSlot, setSelectedTimeSlot] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

   
  

    const handlesetSelectedTimeSlot = (e, timeSlot) => {
        setSelectedTimeSlot(timeSlot);
    }

   
        // props.handlePaymentClick(selectedTimeSlot, );
        const handleConfirmClick = async () => {
        setLoading(true);
        setError(false);
       
        
        
        await ErpAxios.post(BOOKING_URL, {
                account_id: props.account.account_id,
                property_id: props.account.primary_property_id,
                service_date: props.selectedDate,
                selected_slot: selectedTimeSlot,
                duration: props.items.data[props.selectedDate]['duration'],
                current_inspection_id: props.selectedBooking ? props.selectedBooking.inspection : null,
                service_type: props.serviceType ? props.serviceType : 'ac-qd',
                area_of_service: props.areaofService,
                account_type: 'existing',
                request_type: 'new'
        })
            .then(response => {
                console.log(response);

                if (response.data.status === true) {
                   setLoading(false);
                    setError(false);
                    props.nextStep(selectedTimeSlot);
                }else{
                  setLoading(false);
                    setError(true); 
                }
                
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                setError(true);
            })


       
    }

    const handlePrevStepClick = (e) => {
        e.preventDefault();
        props.doPreviousStep();
        setSelectedTimeSlot();
     

    }


    return (
        <div>
  {(loading) && <div className="w-full flex justify-center mb-3"><Loader fullHeight={false} /></div>}
           
          
           

           
            
                
            <div>
                 <div className="w-full flex justify-end mb-3">
                <button onClick={handlePrevStepClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="cursor-pointer"
                        width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM19.3 19.3C18.91 19.69 18.28 19.69 17.89 19.3L15 16.41L12.11 19.3C11.72 19.69 11.09 19.69 10.7 19.3C10.5127 19.1132 10.4075 18.8595 10.4075 18.595C10.4075 18.3305 10.5127 18.0768 10.7 17.89L13.59 15L10.7 12.11C10.5127 11.9232 10.4075 11.6695 10.4075 11.405C10.4075 11.1405 10.5127 10.8868 10.7 10.7C11.09 10.31 11.72 10.31 12.11 10.7L15 13.59L17.89 10.7C18.28 10.31 18.91 10.31 19.3 10.7C19.69 11.09 19.69 11.72 19.3 12.11L16.41 15L19.3 17.89C19.68 18.27 19.68 18.91 19.3 19.3Z" fill="#333333" />
                    </svg>
                </button>
            </div>
                <p className=" text-xl font-light">Dear {props.account?.client_name},</p>
                
                
                
                <div className="mt-5 mb-5 gap-1.5 flex flex-col">
                    <p className="md:text-sm text-xs font-normal">Select your <b>{service_title}</b> Inspection Slot:</p>


                      <div className="table align-middle w-full mb-2">
    <div className="table-row text-xs mb-0">
      <div className="table-cell  w-4/12 border-b border-t py-2 px-1">
        Location:
      </div>
      <div className="table-cell border-b border-t  py-2 font-bold">
       {props.primaryPropertyAddress}
      </div>
    </div>    </div>
                   
                     <div className='w-full pt-0'>   {props.items?.data?.[props.selectedDate]?.time_ranges?.map((timeRange, index) => (
                  
                   
                        <div key={index} className="bg-primary-05 rounded hover:bg-primary/10">
                            <label className="flex items-center justify-between space-x-2 cursor-pointer py-1.5 px-2.5">
                                <p className="text-xs">{timeRange}</p>
                                <input
                                    type="checkbox"
                                    name="timeSlot"
                                    value={timeRange}
                                    className="h-5 w-5 appearance-none
   focus:outline-none  ring-0 rounded
   checked:bg-danger  focus:ring-0 focus:ring-primary/20 checked:text-danger border-1 border-primary/20
  checked:border-0 ring-offset-0 focus:ring-offset-0"
                                    onChange={(e) => handlesetSelectedTimeSlot(e, timeRange)}
                                    checked={selectedTimeSlot === timeRange}

                                />

                            </label>

                        </div>
                    ))}
                    </div> 
                </div>

                <div className="w-full border-t py-2  mb-5  border-b border-primary/30">
                    <div className="table align-middle w-full">
                        <div className="table-row md:text-sm text-xs font-normal text-primary">
                            <div className="table-cell w-8/12 pb-1">
                                INSPECTION DATE
                            </div>
                            <div className="table-cell w-4/12 text-right pb-1">
                                TYPE
                            </div>
                        </div>
                        <div className="table-row text-xs font-normal text-primary">
                            <div className="table-cell w-8/12">
                            {props.selectedBooking && (
                                <div>
                                   
                                    <div className='font-medium pb-1'>
                                            {dayjs(props.selectedDate).format('MMMM D, YYYY')}
                                    </div>
                                    <div className='line-through text-primary/50 decoration-primary/50'>
                                            {dayjs(props.selectedBooking.service_date).format('MMMM D, YYYY')}
                                    </div>
                                </div>
                            )}
                             {!props.selectedBooking && (
                                <div>
                                    {dayjs(props.selectedDate).format('MMMM D, YYYY')}
                                </div>
                            )}
                            </div>
                            <div className="table-cell w-4/12 text-right  text-danger">
                                
                              <div>FREE INSPECTION</div>
                            </div>
                        </div>

                    </div>

                </div>
              
                  
             

              
                {selectedTimeSlot && (
                <button className={`w-full text-white py-2 text-sm rounded font-bold ${!selectedTimeSlot ? "bg-danger/50 cursor-not-allowed" : "bg-danger hover:bg-danger/80"}`}
                    onClick={handleConfirmClick}

  


                    disabled={!selectedTimeSlot}
                >Confirm Your Inspection</button>
                )}

               
            </div>

          
 


        </div>
    );
}
export default Options;